import React, {useMemo} from "react";
import {Card} from "peggirkit";
import {EmployeeDashboardProps} from "@widgets/timeRegistration/EmployeeDashboard";
import {EmployeeStatus} from "@/data/entities/employee";
import {FormattedMessage} from "react-intl";
import EmployeeCardHeader from "@widgets/timeRegistration/authenticated/header/EmployeeCardHeader";
import EmployeeIdentity from "@widgets/timeRegistration/authenticated/header/EmployeeIdentity";
import TimeEntriesList from "@widgets/timeRegistration/authenticated/timeEntries/TimeEntriesList";
import ClockToggle from "@widgets/timeRegistration/authenticated/clocking/ClockToggle";

type Props = EmployeeDashboardProps & {
    employee: EmployeeStatus,
    wrapInCard: boolean,
};

const ClockSystem = ({employee, setEmployee, wrapInCard}: Props) => {
    const isClockedIn = useMemo(
        () => employee.timeEntries.length > 0 && employee.timeEntries[0].clockOut === null,
        [employee.timeEntries]);

    const content = (
        <div className={"w-full flex flex-col gap-8"}>
            <EmployeeIdentity
                employee={employee}
                isClockedIn={isClockedIn}
            />

            <ClockToggle
                setEmployee={setEmployee}
                employee={employee}
                isClockedIn={isClockedIn}
            />

            <div className={"w-full border-t border-t-gray-200 dark:border-t-gray-700 pt-8 flex flex-col gap-4"}>
                <h2 className={"uppercase text-gray-500 text-[80%]"}>
                    <FormattedMessage id={"previousRegistrations"}/>
                </h2>

                <TimeEntriesList employee={employee}/>
            </div>
        </div>
    );

    if (!wrapInCard)
        return <>{content}</>;

    return (
        <Card header={<EmployeeCardHeader setEmployee={setEmployee}/>}>
            {content}
        </Card>
    );
};

export default ClockSystem;